module.exports = __webpack_public_path__ + "img/app-store-new.f3b2dfab.png";